export default class UtilNumber{

    static toNumber = (value) => {

        // Handle null, undefined, or empty
        if (value === null || value === undefined || value === ''){
            return 0
        } 

        // If it's already a number, return safely
        if (typeof value !== 'string') {
            const numberValue = Number(value)
            return isNaN(numberValue) ? 0 : numberValue
        }

        // Clean spaces, "R$" and trim
        let cleaned = value.trim().replace('R$', '').replace(/\s/g, '')

        // If it uses a comma for decimals (e.g. "1.234,56")
        if (cleaned.includes(',')) {
            cleaned = cleaned.replace(/\./g, '').replace(',', '.')
        }

        // If it uses dot for decimals (e.g. "1000.00"), skip dot removal
        const result = parseFloat(cleaned)
        return isNaN(result) ? 0 : result

    };

    static isNumber = (valor) =>{

        return Number.isFinite(this.toNumber(valor));

    };

    static clamp = (value, min, max) => {
        return Math.min(Math.max(this.toNumber(value), this.toNumber(min)), this.toNumber(max));
    }

    static round = (valor = 0) =>{

        return Math.round(this.toNumber(valor) * 100) / 100 

    }

    static formatSequence = (options = {}) =>{

        let {
            valor = 0,
            preencher = 0
        } = options;

        let sequenciaNumero = this.toNumber(valor);
        let sequenciaNumeroString = `${sequenciaNumero}`;
        let sequenciaNumeroFormatada = sequenciaNumeroString?.padStart(preencher,"0");

        return sequenciaNumeroFormatada;

    }

    static getNextSequence = (options = {}) =>{

        let {
            valor = 0,
            preencher = 0
        } = options;

        let sequenciaNumero = this.toNumber(valor);
        let sequenciaNumeroIncrementada = `${sequenciaNumero + 1}`;
        let sequenciaNumeroFormatada = sequenciaNumeroIncrementada?.padStart(preencher,"0");

        return sequenciaNumeroFormatada;

    }

    static isPercentage = (valor) =>{

        if(valor === ""){
            return false;
        }

        valor = this.toNumber(valor);

        return valor >= 0 && valor <= 100;

    };

    static isNotPercentage = (valor) =>{

        return !this.isPercentage(valor);

    };

    static getPercentage(options = {}){

        let {
            parte = 0,
            total = 0,
            maximo = 999999999,
            arredondar = true
        } = options;

        // Evita divisão por Zero
        if(this.toNumber(total) === 0){
            return 0; 
        }
        
        let porcentagem = (this.toNumber(parte) / this.toNumber(total)) * 100;
        porcentagem = UtilNumber.clamp(porcentagem,0,this.toNumber(maximo));

        if(arredondar){
            return this.round(porcentagem);
        }

        return porcentagem;

    }

    static getValueFromPercentage(options = {}){

        let {
            porcentagem = 0,
            valor = 0,
            arredondar = true
        } = options;

        // Trata Valores
        valor = this.toNumber(valor);
        porcentagem = this.toNumber(porcentagem)

        // Se Valor igual a Zero, evita divisão por zero.
        if(valor === 0){
            return 0; 
        }

        // Calcula o valor pela Porcentagem
        valor = (porcentagem / 100) * valor;

        // Se Arredondamento esperado, arredonte o valor.
        if(arredondar){
            return this.round(valor);
        }
        
        return valor;

    }

}